import { Box, Divider, Grid, Typography } from '@mui/material';
import { BreathingSparkAnimation } from 'components/Animations';
import React from 'react';
import { SparkImageLoader, SparkProgressBar } from 'sharedComponents/UI';

function BoardLoadingScreen() {
  return (
    <Grid
      display='flex'
      direction='column'
      justifyContent='center'
      alignItems='center'
      height='100%'
      container
      position='relative'
    >
      <Box
        position='absolute'
        top='10%'
        sx={{ transform: 'translate(-90%,-50%)' }}
      >
        <SparkImageLoader src='/SparkLogo.png' alt='spark-logo' width={300} />
      </Box>
      <Box display='flex' justifyContent='center' alignItems='center'>
        <BreathingSparkAnimation width={'10rem'} height={'10rem'} />
        <Divider orientation='vertical' />
        <Box paddingLeft={2}>
          <Typography fontFamily='Mont-SemiBold' variant='h4'>
            Quick Tip
          </Typography>
          <Typography variant='h6'>
            Users who share their boards 4x their productivity
          </Typography>
          <SparkProgressBar
            value={10}
            variant='indeterminate'
            renderPercentage={false}
            sx={{ height: '15px', borderRadius: '10px' }}
          />
        </Box>
      </Box>
    </Grid>
  );
}

export default BoardLoadingScreen;
